

// @ts-nocheck

import React, { useState } from 'react'
import SoftBox from '../../../components/common/softBox';
import SoftTypography from '../../../components/common/softTypography';
import SoftInput from '../../../components/common/softInput';
import SoftButton from '../../../components/common/softButton';
import { useDispatch } from 'react-redux';
import { createRoomType } from '../../../features/roomType';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';


const AddRoomType = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [images, setImages] = useState<File[]>([]);
    const [formData, setFormData] = useState({
        name: "",
        description: "",
        base_price: 0,
        max_occupancy: "",
        size: "",
        link: "",

    });
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        console.log(name,'name');
        console.log(typeof(Number(value)),'value');



          setFormData((prev) => ({
            ...prev,
            [name]: name === 'base_price' ? Number(value) : value,
        }));
    
       
   
    };

    const handleAddImages = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files) {
        const newImages = Array.from(event.target.files); 
        setImages((prevImages) => [...prevImages, ...newImages]);
      }
    };
  
    const handleRemoveImage = (index: number) => {
      setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    };
console.log(images,'images');

    const handleSubmit = () => {
      const formDataWithImages = new FormData();
      formDataWithImages.append('name', formData.name);
      formDataWithImages.append('description', formData.description);
      formDataWithImages.append('base_price', formData.base_price.toString());
      formDataWithImages.append('max_occupancy', formData.max_occupancy);
      formDataWithImages.append('size', formData.size);
      formDataWithImages.append('link', formData.link);
  
      // Append selected images to the FormData object
      images.forEach((image) => {
        formDataWithImages.append('photos', image);
      });

console.log(formData,'formData');

     dispatch(createRoomType(formDataWithImages))
     .then((res) => {
       console.log(res, 'res.payload');
       
       if (res.meta.requestStatus === 'fulfilled') {
         toast.success(res.payload.message);  // Show success toast
         navigate('/room-type');  // Navigate to the room-type page
       } else {
         toast.error('Failed to create room type');
       }
     })
     .catch((err) => {
       console.error('Error during room type creation:', err);
      //  toast.error('An error occurred while creating room type');
     });

    }
    return (
        <SoftBox
        display="flex"
        justifyContent="center"
        alignItems="center"
     
        bgColor="white"
        shadow="lg"
        borderRadius="lg"
        p={4}
      >
        <SoftBox width="100%" maxWidth="400px" >

          <SoftBox mb={2}>

            <SoftTypography variant="h4" fontWeight="bold" textAlign="center" >
              Room Type
            </SoftTypography>
          </SoftBox>

          <SoftBox component="form" role="form">

            <SoftBox mb={2}>

              <SoftBox mb={1} ml={0.5}>

                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Name
                </SoftTypography>
              </SoftBox>

              <SoftInput

                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
              />
            </SoftBox>
  
            <SoftBox mb={2}>

              <SoftBox mb={1} ml={0.5}>

                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Description
                </SoftTypography>
              </SoftBox>
              <SoftInput

                type="text"
                name="description"
                placeholder="Description"
                value={formData.description}
                onChange={handleChange}
              />
            </SoftBox>
  
            <SoftBox mb={2}>

              <SoftBox mb={1} ml={0.5}>

                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Price
                </SoftTypography>
              </SoftBox>
              <SoftInput

                type="number"
                name="base_price"
                placeholder="Price"
                value={formData.base_price}
                onChange={handleChange}
              />
            </SoftBox>

            <SoftBox mb={2}>
          

          <SoftBox mb={1} ml={0.5}>
        

            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Max Occupancy
            </SoftTypography>
          </SoftBox>
          <SoftInput
            type="number"
            name="max_occupancy"
            placeholder="Enter the max occupancy"
            value={formData.max_occupancy}
            onChange={handleChange}
          />
        </SoftBox>

        

        <SoftBox mb={2}>
        

          <SoftBox mb={1} ml={0.5}>
        

            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Size
            </SoftTypography>
          </SoftBox>
          <SoftInput
      //    @ts-ignore 

            type="text"
            name="size"
            placeholder="Enter the room size"
            value={formData.size}
            onChange={handleChange}
          />
        </SoftBox>

        <SoftBox mb={2}>
        

        <SoftBox mb={1} ml={0.5}>
      

          <SoftTypography component="label" variant="caption" fontWeight="bold">
            Link
          </SoftTypography>
        </SoftBox>
        <SoftInput

          type="text"
          name="link"
          placeholder="Enter the link"
          value={formData.link}
          onChange={handleChange}
        />
      </SoftBox>

      <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Select Images
              </SoftTypography>
            </SoftBox>
            <input type="file" accept="image/*" multiple onChange={handleAddImages} style={{ marginBottom: '20px' }} />
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {images.map((image, index) => (
                <div key={index} style={{ position: 'relative' }}>
                  <img
                    src={URL.createObjectURL(image)}
                    alt="Preview"
                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                  />
                  <button
                    onClick={() => handleRemoveImage(index)}
                    style={{
                      position: 'absolute',
                      top: '5px',
                      right: '5px',
                      background: 'red',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      cursor: 'pointer',
                    }}
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
          </SoftBox>



  
            <SoftBox mt={4} mb={1}>

              <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
                Submit
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    )
}

export default AddRoomType